import React from 'react';
import './User.less';
import User from './AddUser';

const UserLayout = (props) => (
  <div>
    <User />
  </div>
);
export default UserLayout;
